/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import './scss/bootstrap-theme.scss';
import './css/glyphicons.css';
import './css/style.css';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import {Provider} from 'react-redux';
import {createEpicMiddleware} from 'redux-observable';
import rootEpic from './epics';
import rootReducer from './reducers';
import {Route} from 'react-router';
import Layout from './components/Layout';
import {Route as LoginUIRoute} from './routes';
import ResetPassword from './scenes/ResetPassword';
import Login from './scenes/Login';
import FlexServiceWorkerRegistration from './scenes/FlexServiceWorkerRegistration';
import ConfirmEmployeeRegistration from './scenes/ConfirmEmployeeRegistration';
import AccountRecovery from './scenes/AccountRecovery';
import AccountEmailChange from './scenes/AccountEmailChange';
import {BrowserRouter, Routes} from 'react-router-dom';
import {OutHookInitializer} from './components/OutHook';
import {createRoot} from 'react-dom/client';
import React from 'react';
import {configureStore} from '@reduxjs/toolkit';
import {applicationStarted} from './actions';

const epicMiddleWare = createEpicMiddleware();
const store = configureStore({
	reducer: rootReducer,
	middleware: [epicMiddleWare]
});

epicMiddleWare.run(rootEpic);
store.dispatch(applicationStarted());

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<Layout>
				<BrowserRouter basename={process.env.PUBLIC_URL}>
					<OutHookInitializer/>
					<Routes>
						<Route path={LoginUIRoute.ACCOUNT_EMAIL_CHANGE} element={<AccountEmailChange/>}/>
						<Route path={LoginUIRoute.ACCOUNT_RECOVERY} element={<AccountRecovery/>}/>
						<Route path={LoginUIRoute.CONFIRM_EMPLOYEE_REGISTRATION} element={<ConfirmEmployeeRegistration/>}/>
						<Route path={LoginUIRoute.FLEX_SERVICE_WORKER_REGISTRATION} element={<FlexServiceWorkerRegistration/>}/>
						<Route path={LoginUIRoute.LOGIN} element={<Login/>}/>
						<Route path={LoginUIRoute.RESET_PASSWORD} element={<ResetPassword/>}/>
					</Routes>
				</BrowserRouter>
			</Layout>
		</Provider>
	</React.StrictMode>
);
